<template>
	<div class="box">
		<CustomTable
			ref="embryonsTable"
			id_table="embryons_available"
			:items="embryons"
			:busy.sync="table_busy"
			primaryKey="embryon_id"
			:hrefsRoutes="config_table_hrefs"
			:externSlotColumns="['embryon_stade']"
		>
			<template v-slot:[`custom-slot-cell(embryon_stade)`]="{ data }">
				{{ $t('gynecologie.embryon.'+data.embryon_stade) }}
			</template>
		</CustomTable>

		<b-modal ref="modalEditEmbryon" size="lg" hide-footer>
			<template v-slot:modal-title>
				<template>
					{{ $t("gynecologie.edit_embryon") }}
				</template>
			</template>

			<div>
				<b-checkbox v-model="embryon_congele" class="mr-3 d-inline">
					{{ $t('gynecologie.embryon.congele')}}
				</b-checkbox>

				<b-checkbox v-model="embryon_detruit" class="d-inline">
					{{ $t('gynecologie.embryon.detruit')}}
				</b-checkbox>
			</div>

			<div class="form-group">
				<label for="skip" class="col-form-label">{{ $t("gynecologie.embryon.commentaire") }}</label>
				<input type="text" class="form-control" v-model="embryon_commentaire">
			</div>

			<div class="row mt-2 align-items-center">
				<div class="col-auto">
					<b-input-group :prepend="$t('gynecologie.embryon.taille')">
						<b-input v-model="embryon_taille" />
					</b-input-group>
				</div>
				<div class="mt-3 mt-lg-0 col-lg">
					<b-input-group :prepend="$t('gynecologie.embryon.stade')">
                        <e-select
                            v-model="embryon_stade"
                            :placeholder="getTrad('gynecologie.embryon.select_stade')"
                            :options="all_stades"
                            :searchable="true"
                            :show-labels="false"
						>
							<template slot="option" slot-scope="{ option }">{{ $t('gynecologie.embryon.'+option) }}</template>
							<template slot="singleLabel" slot-scope="{ option }">{{ $t('gynecologie.embryon.'+option) }}</template>
                        	<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
					</b-input-group>
				</div>
			</div>

			<b-button class="mt-3 btn-block rounded-pill" variant="primary" @click="edit">{{ $t("global.modifier") }} <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse  class="mr-1"/></b-button>
		</b-modal>

		<b-modal ref="modalAddEmbryon" size="lg" hide-footer @shown="bindSaveShortcut" @hidden="unbindSaveShortcut">
			<template v-slot:modal-title>
				<template>
					{{ $t("gynecologie.add_embryon") }}
				</template>
			</template>

			<div class="form-group">
				<label class="col-form-label">{{ $t('monte.etalon') }} *</label>
				<e-select
					v-model="embryon_stallion"
					id="stallion"
					track-by="horse_id"
					label="horse_nom"
					:placeholder="$t('monte.selectionnez_etalon')"
					:selectedLabel="$t('global.selected_label')"
					:options="stallions"
					:searchable="true"
					:allow-empty="true"
					:show-labels="false"
				/>
			</div>

			<div class="form-group">
				<label class="col-form-label">{{ $t('monte.jument') }} *</label>
				<e-select
					v-model="embryon_mare"
					id="mare"
					track-by="horse_id"
					label="horse_nom"
					:placeholder="$t('monte.selectionnez_jument')"
					:selectedLabel="$t('global.selected_label')"
					:options="mares"
					:searchable="true"
					:allow-empty="true"
					:show-labels="false"
				/>
			</div>

			<div class="text-right mb-3">
				<b-button @click="addEmbryonRow">
					<font-awesome-icon :icon="['fal', 'plus']" />
					{{ $t('gynecologie.embryon.ajouter') }}
				</b-button>
			</div>

			<div
				v-for="(embryon, index) in embryons_to_add"
				:key="embryon.embryon_id"
				class="list_embryons mb-3"
			>
				<div class="row align-items-center">
					<div class="col-auto">
						<div class="embryo_number">{{ $t('gynecologie.embryon.numero') }} {{ index + 1 }}</div>
					</div>
					<div class="col-auto order-lg-last embryo_delete" v-if="embryons_to_add.length > 1">
						<b-button variant="secondary" @click="removeEmbryonRow(embryon.embryon_id)">
							<font-awesome-icon :icon="['fal', 'trash-alt']" />
						</b-button>
					</div>
					<div class="col-auto">
						<b-checkbox v-model="embryon.embryon_congele" class="mr-3 d-inline">
							{{ $t('gynecologie.embryon.congele') }}
						</b-checkbox>

						<b-checkbox v-model="embryon.embryon_detruit" class="d-inline">
							{{ $t('gynecologie.embryon.detruit') }}
						</b-checkbox>
					</div>
					<div class="col-12 mt-3 mt-lg-0 col-lg">
						<b-input-group :prepend="$t('gynecologie.embryon.commentaire')">
							<b-input v-model="embryon.embryon_commentaire" />
						</b-input-group>
					</div>
				</div>
				<div class="row mt-2 align-items-center mx-lg-5">
					<div class="col-auto">
						<b-input-group :prepend="$t('gynecologie.embryon.taille')">
							<b-input v-model="embryon.embryon_taille" />
						</b-input-group>
					</div>
					<div class="mt-3 mt-lg-0 col-lg">
						<b-input-group :prepend="$t('gynecologie.embryon.stade')">
							<e-select
								v-model="embryon.embryon_stade"
								:placeholder="getTrad('gynecologie.embryon.select_stade')"
								:options="all_stades"
								:searchable="true"
								:show-labels="false"
							>
								<template slot="option" slot-scope="{ option }">{{ $t('gynecologie.embryon.'+option) }}</template>
								<template slot="singleLabel" slot-scope="{ option }">{{ $t('gynecologie.embryon.'+option) }}</template>
								<template slot="noOptions">{{ $t('global.list_empty') }}</template>
							</e-select>
						</b-input-group>
					</div>
				</div>
				<div class="row mt-2 align-items-center mx-lg-5" v-if="embryons_to_add.length === 1">
					<div class="col-auto">
						<b-checkbox v-model="embryon.affect_embyron" class="d-inline">
							{{ $t('gynecologie.embryon.affect') }}
						</b-checkbox>
					</div>
					<div class="col">
						<b-input-group v-if="embryon.affect_embyron" :prepend="$t('monte.porteuse')">
							<e-select
								v-model="embryon.embryon_porteuse"
								track-by="horse_id"
								label="horse_nom"
								:placeholder="$t('monte.selectionnez_jument')"
								:selectedLabel="$t('global.selected_label')"
								:options="mares"
								:searchable="true"
								:allow-empty="true"
								:show-labels="false"
							/>
						</b-input-group>
					</div>
				</div>
			</div>

			<b-button class="mt-3 btn-block rounded-pill" variant="primary" @click="add" :disabled="processing">
				<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
				{{ processing ? $t("global.chargement") : $t("global.ajouter") }}
				<span class="ml-1 small opacity-50">({{ isMac ? '⌘' : 'Ctrl' }}+S)</span>
			</b-button>
		</b-modal>

		<b-modal ref="modalConfirmDeleteEmbryon" hide-footer>
			<template v-slot:modal-title>
				<template>
					{{ $t("gynecologie.embryon.title_suppression") }}
				</template>
			</template>

			<div class="text-center">
				{{ $t("gynecologie.embryon.confirm_suppression") }}<br>

				<b-button class="mt-3 rounded-pill" variant="primary" @click="toDelete">{{ $t("global.supprimer") }} <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse  class="mr-1"/></b-button>
			</div>
		</b-modal>

		<b-modal ref="modalExpeditionEmbryon" hide-footer>
			<template v-slot:modal-title>
				<template>
					{{ $t("gynecologie.embryon.expedition") }}
				</template>
			</template>

			<div class="text-center">
				<SearchTiers 
					:tiers_selected.sync="destinataire"
				/>

				<b-button class="mt-3 rounded-pill" variant="primary" @click="toExpedition">{{ $t("global.valider") }} <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse  class="mr-1"/></b-button>
			</div>
		</b-modal>

		<ActionOverlay ref="saveOverlay" :loadingText="$t('gynecologie.embryon.enregistrement_en_cours')" :successText="$t('gynecologie.embryon.enregistrement_succes')" />
	</div>
</template>

<script>
import Common from '@/assets/js/common'
import Embryon from '@/mixins/Embryon'
import Navigation from "@/mixins/Navigation.js";
import Actes from "@/mixins/Actes.js";

export default {
	name: 'EmbryonAvailable',
	mixins: [Embryon, Navigation, Actes],
	data () {
		return {
			table_busy: true,
			embryons: [],
			embryon_id: null,
			embryon_detruit: null,
			embryon_congele: null,
			embryon_commentaire: null,
			embryon_taille: '',
			embryon_stade: '-',
			embryon_mare: null,
			embryon_stallion: null,
			all_stades: ['-','MOR','JBL','BLA','BLE'],
			processing: false,
			embryon_to_delete: [],
			destinataire: null,
			embryon_to_exp: [],
			stallions: [],
			mares: [],
			embryons_to_add: [],
			saveHandler: null,
			config_table_hrefs: {
				'collecte.horse.horse_nom': {
					routeUniqueName: 'MareFicheInfo',
					routeName: 'HorseFicheInfo',
					params: {
						horse_id: 'collecte.horse.horse_id'
					}
				},
				'collecte.season_mare_stallion.horse.horse_nom': {
					routeUniqueName: 'StallionFicheInfo',
					routeName: 'HorseFicheInfo',
					params: {
						horse_id: 'collecte.season_mare_stallion.horse.horse_id'
					}
				}
			},
			events_tab: {
				'TableAction::goToEditEmbryon': (embryon) => {
					this.openModal(embryon)
				},
				'TableAction::goToDeleteEmbryon': (embryon) => {
					this.checkTransplantation(embryon)
				},
				'TableAction::goToExpditionEmbryon': (embryons) => {
					this.askDestinataire(embryons)
				},
				'TableAction::goToAddEmbryon': () => {
					this.openModal()
				},
			}
		}
	},
	created() {
		this.init_component()
	},
	beforeDestroy() {
		this.unbindSaveShortcut()
	},
	methods: {
		async init_component() {
			this.stallions = await this.getHorsesStallion(false)
			this.mares = await this.getHorseFemelle()

			try {
				this.table_busy = true

				this.embryons = await this.getAvailableEmbryons()
			}
			finally {
				this.table_busy = false
			}
		},
		openModal(embryon) {
			if(embryon) {
				this.embryon_id = embryon.embryon_id
				this.embryon_detruit = embryon.embryon_detruit
				this.embryon_congele = embryon.embryon_congele
				this.embryon_commentaire = embryon.embryon_commentaire
				this.embryon_taille = embryon.embryon_taille
				this.embryon_stade = embryon.embryon_stade
				this.$refs.modalEditEmbryon.show()
			}
			else {
				this.embryon_mare = null
				this.embryon_stallion = null
				this.embryons_to_add = [this.getDefaultEmbryon()]
				this.$refs.modalAddEmbryon.show()
			}
		},
		getDefaultEmbryon() {
			return {
				embryon_id: -Common.getRandomInt(9999999),
				embryon_congele: false,
				embryon_detruit: false,
				embryon_commentaire: '',
				embryon_taille: '',
				embryon_stade: '-',
				affect_embyron: false,
				embryon_porteuse: null
			}
		},
		addEmbryonRow() {
			this.embryons_to_add.push(this.getDefaultEmbryon())
		},
		removeEmbryonRow(embryon_id) {
			const index = this.embryons_to_add.findIndex(e => e.embryon_id === embryon_id)
			if(index !== -1) {
				this.embryons_to_add.splice(index, 1)
			}
		},
		bindSaveShortcut() {
			this.unbindSaveShortcut()
			this.saveHandler = (e) => {
				if((this.isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === 's') {
					e.preventDefault()
					if(!this.processing) {
						this.add()
					}
				}
			}
			window.addEventListener('keydown', this.saveHandler)
		},
		unbindSaveShortcut() {
			if(this.saveHandler) {
				window.removeEventListener('keydown', this.saveHandler)
				this.saveHandler = null
			}
		},
		checkTransplantation(embryon) {
			this.embryon_to_delete = embryon
			if(this.embryon_to_delete.transplantation) {
				this.$refs.modalConfirmDeleteEmbryon.show()
			}
			else {
				this.toDelete()
			}
		},
		toDelete() {
			this.deleteEmbryon(this.embryon_to_delete.embryon_id)
			.then(() => {
				this.processing = false
				if(this.$refs.modalConfirmDeleteEmbryon) {
					this.$refs.modalConfirmDeleteEmbryon.hide()
				}
				this.init_component()
			})
		},
		edit() {
			this.processing = true
			this.editEmbryon(this.embryon_id, this.embryon_detruit, this.embryon_commentaire, this.embryon_taille, this.embryon_stade, this.embryon_congele)
			.then(() => {
				this.processing = false
				this.$refs.modalEditEmbryon.hide()
				this.init_component()
			})
		},
		async add() {
			if(!this.embryon_mare || !this.embryon_stallion) {
				return false
			}
			if(this.embryons_to_add.length === 0) {
				return false
			}

			this.processing = true
			this.table_busy = true
			this.$refs.saveOverlay.show()
			try {
				const created_embryons = []
				for(const row of this.embryons_to_add) {
					const payload = {
						embryon_detruit: row.embryon_detruit,
						embryon_commentaire: row.embryon_commentaire,
						embryon_taille: row.embryon_taille,
						embryon_stade: row.embryon_stade || '-',
						embryon_congele: row.embryon_congele,
						embryon_mare: this.embryon_mare.horse_id,
						embryon_stallion: this.embryon_stallion.horse_id
					}
					const res = await this.addEmbryon(payload)
					created_embryons.push({ row, embryon: res.retour })
				}

				const to_affect = created_embryons.filter(c => c.row.affect_embyron && c.row.embryon_porteuse)

				if(to_affect.length === 1) {
					const c = to_affect[0]
					c.embryon.embryon_porteuse = c.row.embryon_porteuse
					this.$refs.modalAddEmbryon.hide()
					await this.$refs.saveOverlay.showSuccess()
					await this.createActeEmbryon(c.embryon)
				}
				else {
					await this.$sync.force(true)
					await this.init_component()
					if(this.$refs.embryonsTable) {
						this.$refs.embryonsTable.refreshTable()
					}
					this.$refs.modalAddEmbryon.hide()
					await this.$refs.saveOverlay.showSuccess()
				}
			}
			catch(e) {
				this.$refs.saveOverlay.hide()
				throw e
			}
			finally {
				this.processing = false
			}
		},
		askDestinataire(embryons) {
			this.embryon_to_exp = embryons
			this.$refs.modalExpeditionEmbryon.show()
		},
		toExpedition() {
			this.expeditionEmbryon(this.embryon_to_exp, this.destinataire.tiers_id)
			.then(() => {
				this.$refs.modalExpeditionEmbryon.hide()
				this.init_component()
			})
		},
		async createActeEmbryon(embryon) {
			const collecte_date = new Date()
			let label = `#${embryon.embryon_num}`
			if(embryon.mare)
				label = `#${embryon.embryon_num} - ${embryon.mare.horse_nom}`

			if(embryon.stallion) {
				label += ` x ${embryon.stallion.horse_nom}`
			}

			label += ` - ${this.getTrad('reponses.Collecté le')} ${collecte_date.toLocaleDateString(this.$i18n.locale())}`

			if(embryon.embryon_congele) {
				label += ' - ' + this.getTrad('reponses.Congelé')
			}

			const acte_type = await this.getActeTypeByCode('REPRO_TRANSPLANTATION_EMBRYONNAIRE')
			const questions = await this.$storage.db.t('question')
				.then(table => {
					return table.where({
						question_type: 'horse_actes_type',
						question_fk: acte_type.actestype_id,
						question_code: 'Embryons'
					})
					.toArray()
				})

			const reponses = [{
				reponse_data: [label],
				reponse_data_hidden: {type: 'embryon', ids: [embryon.embryon_id]},
				reponse_question: questions[0].question_id
			}]

			const actes = await this.addActes([embryon.embryon_porteuse.horse_id], 0, new Date(), '', acte_type.actestype_id, null, null, [], reponses, null, null)
			this.$router.push({ name: 'acteAjout', params: {acte_id: actes[0], state: 'modification', from: 'embryonAvailable'}})
		}
	},
	components: {
		CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
		SearchTiers : () => import('@/components/Contract/SearchTiers'),
		ActionOverlay: () => import('@/components/Utils/ActionOverlay')
	}
}
</script>
